export var noOp = {};
export default noOp;

//# sourceMappingURL=noOp.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/noOp.js
// module id = 17
// module chunks = 0